// theme-sources/js/theme/theme-ziggy.js

import { bootstrapUI } from "./bootstrap";
import { initCartCheckout } from "./features/cart-checkout";
import { initCollectionNav } from "./features/collection-nav";

bootstrapUI();
initCartCheckout();

document.addEventListener("DOMContentLoaded", () => {
  initCollectionNav();
});
